document.addEventListener("DOMContentLoaded", () => {
  // Empêche le navigateur de scroller automatiquement au hash
  if (window.location.hash) {
    window.scrollTo(0, 0);
  }
});

let smoother;

// Mise en place du smoothscroll et la galère des ancres
window.addEventListener("load", () => {
  gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin);

  if (
    document.querySelector("#smooth-wrapper") &&
    document.querySelector("#smooth-content")
  ) {
    smoother = ScrollSmoother.create({
      wrapper: "#smooth-wrapper",
      content: "#smooth-content",
      smooth: 1.2,
      normalizeScroll: true,
      effects: true,
    });

    const goToHash = () => {
      const hash = window.location.hash;
      if (!hash) return;

      const target = document.querySelector(hash);
      if (!target) return;

      ScrollTrigger.refresh();

      smoother.scrollTo(target, true, "power2.out");
    };

    setTimeout(goToHash, 100);

    // Gestion ancres
    document.querySelectorAll('a[href^="#"]').forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        const target = document.querySelector(link.getAttribute("href"));
        if (target) smoother.scrollTo(target, true, "power2.out");
        history.pushState(null, "", link.getAttribute("href"));
      });
    });
  }
});

//Animation des images du contenu
gsap.utils.toArray(".content-wrapper img").forEach((img) => {
  if (!img) return;

  gsap.set(img, { autoAlpha: 0.7, y: 50 });

  gsap.to(img, {
    autoAlpha: 1,
    y: 0,
    ease: "power2.out",
    scrollTrigger: {
      trigger: img,
      start: "top bottom",
      end: "50%",
      scrub: true,
    },
  });
});

//Gestion bouton retour en haut
const backToTop = document.querySelector(".goToTop");

if (backToTop) {
  ScrollTrigger.create({
    start: "top -40%",
    onEnter: () => gsap.to(backToTop, { autoAlpha: 1 }),
    onLeaveBack: () => gsap.to(backToTop, { autoAlpha: 0 }),
  });

  backToTop.addEventListener("click", () => {
    if (smoother) smoother.scrollTo(0, true);
  });
}
